<template>
  <div class="technology">
    <div class="technology-bg">
      <div class="technology-bg-img">
        <img src="@/assets/technology/banner.png" alt="">
      </div>
      <div class="technology-bg-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">{{ $t('technology.breadcrumb.title') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('technology.breadcrumb.activeTitle') }}</li>
          </ol>
        </nav>
      </div>
      <div class="technology-bg-position"></div>
      <div class="pc-fixed-icon" @click="openInquiryForm">
        <img src="@/assets/home/xinxi.png" alt="">
      </div>
    </div>
    <div class="home-technology">
      <div class="home-technology-div">
        <div class="area-title-pc">
          <p>{{ technologyList[0]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ technologyList[0]?.value[0]?.subheading }}</p>
        </div>
        <div class="home-technology-cont">
          <div class="banner-box-swiper">
            <swiper 
              :options="swiperOptionTechnology"
              ref="technologySwiper"
            >
              <swiper-slide class="swiper-slide" v-for="(item,index) in technologyList[0]?.value[0]?.content" :key="index">
                  <img :src="item.img" alt=""/>
                  <div class="swiper-slide-text">
                    {{ item.img_title }}
                  </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="indicators">
            <div 
              :class="['item', carouselIndex === index ? 'active' : '']"
              v-for="(_, index) in technologyList[0]?.value[0]?.content.length"
              :key="index"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- rd -->
    <div class="technology-rd">
      <div class="technology-rd-div">
        <div class="area-title-pc">
          <p>{{ technologyList[1]?.value[0]?.title }}</p>
          <p class="area-titleBottom-pc">{{ technologyList[1]?.value[0]?.subheading }}</p>
        </div>
        <div class="technology-rd-cont">
          <div class="technology-rd-cont-div">
            <div class="technology-rd-cont-item">
              <div class="technology-rd-cont-item-title">
                {{ technologyList[1]?.value[0]?.content_title }}
              </div>
              <div class="technology-rd-cont-item-text" v-html="technologyList[1]?.value[0]?.content_content">
              </div>
            </div>
            <div class="technology-rd-cont-item-img">
              <img :src="technologyList[1]?.value[0]?.img" alt="">
            </div>
          </div>
        </div>
        <div class="technology-rd-bottomCont">
          <div class="technology-rd-bottomContImg">
            <img :src="technologyList[2]?.value[0]?.img" alt=""></img>
          </div>
          <div class="technology-rd-bottomCont-title">
            {{ technologyList[2]?.value[0]?.title }}
          </div>
          <div class="technology-rd-bottomCont-titleBottom">
            {{ technologyList[2]?.value[0]?.subheading }}
          </div>
          <div class="technology-rd-bottomCont-text">
            <p v-html="technologyList[2]?.value[0]?.content"></p>
            <!-- <p>{{ $t('technology.RD.bottomText2') }}</p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- qual -->
    <div class="technology-qual">
      <div class="technology-qual-div">
        <!-- <div class="area-title-pc">
          <p>{{ $t('technology.RD.titleTop') }}</p>
          <p class="area-titleBottom-pc">{{ $t('technology.RD.titleBottom') }}</p>
        </div> -->
        
        <div class="technology-qual-cont">
          <div class="area-oneTitle-pc">
            <p class="area-oneTitle-pc-fontSize">{{ technologyList[3]?.value[0]?.title }}</p>
          </div>
          <div class="technology-qual-cont-div">
            <div class="technology-qual-cont-item" v-for="(item, index) in technologyList[3]?.value[0]?.content" :key="index">
              <div class="technology-qual-cont-item-img">
                <img :src="item.img" alt="">
              </div>
              <div class="technology-qual-cont-item-text">
                <div class="technology-qual-cont-item-text-bg"></div>
                <div class="technology-qual-cont-item-text-font">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- International -->
    <div class="technology-inter">
      <div class="technology-inter-div">
        <div class="area-oneTitle-pc">
          <p class="area-oneTitle-pc-fontSize">{{ $t('technology.inter.title') }}</p>
        </div>
        <div class="technology-inter-cont">
          <img src="@/assets/technology/international.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { bus } from '@/utils/bus.js'
import { getBannerListing,getDataList } from '@/api/komo'
let vm = null
export default {
  name: 'technology',
    components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      bannerList: [], //
      technologyList: [],
      carouselIndex: 0, // 当前轮播索引
      // 轮播配置项
      swiperOptionTechnology: {
        effect: 'coverflow', // 使用coverflow效果
        coverflowEffect: {
          rotate: 0, // Y轴旋转角度
          stretch: -62, // 每个slide之间的拉伸值
          depth: 112, // slide的位置深度
          modifier: 1, // 效果倍率
          slideShadows: false // 禁用滑动阴影
        },
        centeredSlides: true, // 居中显示当前slide
        autoplay: {
          delay: 3000, // 自动切换时间间隔
          disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
        },
        loop: true, // 无限循环
        loopAdditionalSlides: 1, // 循环时额外复制的slide数量
        slideToClickedSlide: true, // 点击slide直接切换
        on: {
          // 滑动改变时触发
          slideChange: function() {
            vm.carouselIndex = this.realIndex
          }
        }
      },
      // qual
      qualList: [
        {
          url: require('@/assets/technology/qual-1.png'),
          font:this.$t('technology.quality.font1')
        },
        {
          url: require('@/assets/technology/qual-2.png'),

          font:this.$t('technology.quality.font2')
        },
        {
          url: require('@/assets/technology/qual-3.png'),
          font:this.$t('technology.quality.font3')
        },
        {
          url: require('@/assets/technology/qual-4.png'),
          font:this.$t('technology.quality.font4')
        },
      ]
    }
  },
  async created() {
    vm = this // 保存当前实例引用
    await this.initData();
  },
  methods: {
    async initData () {
      const result = await getBannerListing('4');
      this.bannerList = result.data.list;
      const technologyDatalist = await getDataList(localStorage.getItem('pageId'));
      this.technologyList = technologyDatalist.data.list;
    },
    openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
  },
  mounted () { 
  }
}
</script>

<style scoped>
.technology {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}
.technology-bg {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 2%;
}
.technology-bg-img{
  width: 100%;
  height: 580px;
}
.technology-bg-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.technology-bg-breadcrumb{
  width: 80%;
  height: 10%;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 60px;
  display: flex;
  align-items: center;
  padding-left: 3%;
  position: absolute;
  top: calc(580px - 5%);
  left: 10%;
  z-index: 1;
}
.technology-bg-breadcrumb .breadcrumb{
  margin: 0;
  font-size:1.5rem;
}
.technology-bg-breadcrumb .breadcrumb a{
  color: #959595;
  text-decoration: none;
}
.technology-bg-breadcrumb .breadcrumb-item.active{
  font-weight: bold;
  color: #1E1E1E;
}
.technology-bg-position{ 
  width: 80%;
  margin: 5% auto 0;
  height: 46px;
  display: flex;
  justify-content: center;
  gap: 8%;
}
.technology-bg-position-item{
  padding: 1%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.technology-bg-position-item a{
  color: #1E1E1E;
  text-decoration: none;
}
.technology-bg-position-item-active{
  background: #D5DCC8;
  font-weight: bold;
}
.technology-bg-information{
  position: fixed;
  bottom: 0%;
  right: 7%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}
.technology-bg-information img{
  width: 100%;
  height: 100%;
}

/* technology komo ========================== */
.home-technology {
  width: 100%;
  margin: 0 auto;
  /* background: #F8F9FC; */
}
.home-technology-div{
  margin-top: 20px;
  width: 80%;
  margin: 0 auto;
  height: 100%;
}
.home-technology-title{
  margin: 0;
  padding: 8% 0 5% 0;
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  color: #1E1E1E;
}
.home-technology-titleBottom{
  font-size: 1.5rem;
}
.home-technology-cont{
  
}
.home-technology-cont .swiper-container{
  background-image: unset;
}
.home-technology-cont .banner-box-swiper {
  width: 100%;
  height: 600px;
  overflow: hidden; 
}
.home-technology-cont .swiper-container {
  width: 520px;
  height: 520px;
  overflow: visible;
}
.home-technology-cont .swiper-slide {
  text-align: center;
  transition: 300ms;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.home-technology-cont .swiper-slide .swiper-slide-text{
  position: absolute;
  top: 5%;
  right:5%;
  font-size: 1.8vw;
  color: #fff;
  font-weight: bold;
}
.home-technology-cont .img-container {
  width: 100%;
  height: 100%;
  padding: 6px;
}
.home-technology-cont .img-container img {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
}
      
/* 左侧轮播项样式 */
.home-technology-cont .swiper-slide-prev {
  width: 450px;
  height: 450px;
}
.home-technology-cont .swiper-slide-prev img{
  width: 100%;
  height: 100%;
}

/* 右侧轮播项样式 */
.home-technology-cont .swiper-slide-next {
  width: 450px;
  height: 450px;
} 
.home-technology-cont .swiper-slide-next img{
  width: 100%;
  height: 100%;
}          
  
.home-technology-cont .indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 0;  
}
  
.home-technology-cont .indicators .item {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 10px;
  background: #d9d9d9;
}
.home-technology-cont .indicators .active {
  background: #1e1e1e;
}
.home-technology-cont :deep(.swiper-wrapper){
  align-items: center;
}

/* technology komo end ========================== */
/* rd */
.technology-rd{
  width: 100%;
  height: 100%;
}
.technology-rd-div{
  width: 100%;
  height: 100%;
}
.technology-rd-cont{
  display: flex;
  position: relative;
  width: 100%;
  height: 66%;
  background: #D5DCC880;
  padding:6% 0;
}
.technology-rd-cont-div{
  width: 80%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.technology-rd-cont-item{
  width: 40%;
  padding: 0 3% 0 0;
}
.technology-rd-cont-item-title{
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 2.1vw;
  color: #64715D;
  margin-bottom: 4.5%;
}
.technology-rd-cont-item-text{
  font-family: MicrosoftYaHei;
  font-size: 1.2vw;
  color: #959595;
  line-height: 2;
}
.technology-rd-cont-item-img{
  width: calc(100% - 40%);
  height: 100%;
}
.technology-rd-cont-item-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.technology-rd-bottomCont{
  width: 80%;
  margin: 0 auto;
  padding: 6% 0 0;
}
.technology-rd-bottomContImg{
  width: 100%;
  height: 34%;
}
.technology-rd-bottomContImg img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.technology-rd-bottomCont-title{
  padding: 2% 0;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 2vw;
  color: #64715D;
}
.technology-rd-bottomCont-titleBottom{
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 1.5vw;
  color: #1E1E1E;
  margin-bottom: 1%;
}
.technology-rd-bottomCont-text{
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-size: 1.2vw;
  color:#959595;
  line-height: 2;
}
.technology-rd-bottomCont-text p{

}
/* rd end */
/* quality */
.technology-qual{
  width: 100%;
  height: 100%;
  margin-top: 6%;
}
.technology-qual-div{
  width: 100%;
  height: 100%;
}
.technology-qual-cont{
  display: flex;
  position: relative;
  width: 100%;
  height: 66%;
  background: #D5DCC880;
  padding:0 0 6%;
  flex-direction: column;
}
.technology-qual-cont-div{
  width: 80%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  gap: 1.5%;
}
.technology-qual-cont-item{
  width: calc(100% / 4);
  height: 100%;
  position: relative;
  overflow: hidden;
}
.technology-qual-cont-item-img{
  width: 100%;
  height: 30%;
}
.technology-qual-cont-item-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}
.technology-qual-cont-item-img img:hover{
  transform: scale(1.2);
}
.technology-qual-cont-item-text{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 18%;
}
.technology-qual-cont-item-text-bg{
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  background: #1E1E1E;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 0px 0px 30px 30px;
  opacity: 0.6;
}
.technology-qual-cont-item-text-font{
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  font-family: MicrosoftYaHei;
  font-size: 1.2vw;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

/* quality end */
/* inter */
.technology-inter{
  width: 100%;
  height: 100%;
  padding: 4% 0 6%;
}
.technology-inter-div{
  width: 80%;
  margin: 0 auto;
  height: 100%;
  background: #ffffff;
  border-radius: 40px;
}
.technology-inter-cont{
  padding: 0 0 3% 0;
}
.technology-inter-cont img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>

